import { Axios, AxiosError, AxiosResponse } from 'axios';
import { ListCategoryResponse } from './models';

export class CategoryServiceProps {
  api!: Axios
}

export class CategoryService {
  api!: Axios;

  constructor(props: CategoryServiceProps) {
    this.api = props.api;
  }

  async list(): Promise<AxiosResponse<ListCategoryResponse, AxiosError>> {
    return this.api.get<ListCategoryResponse>('category')
  }
}
